import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex flex-col lg:flex-row items-center justify-center overflow-hidden bg-cream px-6 py-12 lg:px-12 lg:py-0" data-id="element-55">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-30 pointer-events-none" data-id="element-56">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-sage-light blur-[100px]" data-id="element-57" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-gold-light/20 blur-[100px]" data-id="element-58" />
      </div>

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10" data-id="element-59">
        {/* Text Content */}
        <div className="order-2 lg:order-1 flex flex-col items-center lg:items-start text-center lg:text-left space-y-8" data-id="element-60">
          <span className="inline-block py-1 px-3 border border-charcoal/20 rounded-full text-xs tracking-widest uppercase text-charcoal/70 font-sans" data-id="element-61">
            A 14-Day Strategic Protocol for Women 30+
          </span>

          <h1 className="text-5xl lg:text-7xl font-serif font-light leading-[1.1] text-charcoal" data-id="element-62">
            The <span className="text-gold italic font-normal" data-id="element-63">Cortisol</span>{' '}
            <br data-id="element-64" />
            Reset Blueprint
          </h1>

          <p className="text-lg lg:text-xl text-charcoal/80 font-sans font-light leading-relaxed max-w-lg" data-id="element-65">
            The 2-Minute Nerve Discharge Method to Flush Stress, Stop Facial
            Swelling, and End Metabolic Burnout.
          </p>

          <div className="pt-4" data-id="element-66">
            <button className="group relative px-8 py-4 bg-sage text-white font-sans tracking-wide transition-all duration-300 hover:bg-sage-dark hover:shadow-lg hover:-translate-y-0.5 flex items-center gap-3" data-id="element-67">
              <span data-id="element-68">Begin Your Reset</span>
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" data-id="element-69" />
            </button>
            <p className="mt-4 text-xs text-charcoal/50 italic font-serif" data-id="element-70">
              *Instant digital download. Start immediately.
            </p>
          </div>
        </div>

        {/* Image Content */}
        <div className="order-1 lg:order-2 flex justify-center items-center" data-id="element-71">
          <div className="relative w-full max-w-lg lg:max-w-xl aspect-square lg:aspect-[4/5] flex items-center justify-center" data-id="element-72">
            {/* Abstract shape behind image */}
            <div className="absolute inset-0 bg-sage-light/50 rounded-full scale-90 blur-3xl opacity-60" data-id="element-73" />

            <img src="https://cdn.magicpatterns.com/uploads/qfgKisZXh9bHNYgMczv47C/private_openrouter-generated-image-1771693091998.png" alt="The Cortisol Reset Blueprint on tablet and phone" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl transform transition-transform duration-700 hover:scale-[1.02]" data-id="element-74" />
          </div>
        </div>
      </div>
    </section>;
}